import {Equipment} from './equipment';

export class UserSet {
	name:String='';
	equipment:Array<Equipment>=[];
}